export const CHECK_LINK_AVAILABLE = "CHECK_LINK_AVAILABLE";

export const CHECK_LINK_AVAILABLE_PENDING = "CHECK_LINK_AVAILABLE_PENDING";

export const CHECK_LINK_AVAILABLE_SUCCESS = "CHECK_LINK_AVAILABLE_SUCCESS";

export const CHECK_LINK_AVAILABLE_ERROR = "CHECK_LINK_AVAILABLE_ERROR";

export const RESET_PASSWORD = "RESET_PASSWORD";

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

export const RESET_PASSWORD_PENDING = "RESET_PASSWORD_PENDING";

export const DUPLICATE_EMAIL_RESET_PASSWORD = "DUPLICATE_EMAIL_RESET_PASSWORD";

export const CHANGE_PASSWORD_PENDING = "CHANGE_PASSWORD_PENDING";

export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
